/**
 * Assigns progressive cell numbers (1..n) within a layout block, row-major order.
 * Each layout has its own sequence; numbers are unique inside that layout.
 */
export const buildCellNumberMap = (grid) => {
  const map = new Map();
  let index = 0;
  for (const row of grid?.rows || []) {
    for (const column of row.columns || []) {
      index += 1;
      map.set(column.id, index);
    }
  }
  return map;
};
 